import 'core-js';

// Vue Plugins
import vue from 'vue';
import v2s from 'vue-script2';
import notification from '@/utils/notification';
import common from '@/mixins/common';
import store from '@/store';

// Vue Components
import compareBar from '@/components/containers/plp/CompareBar';
import compareRackContainer from '@/components/compare/CompareRackContainer';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import TrekFooter from '@/components/TrekFooter';

// Legacy Modules
import loadingIndicator from '@/modules/loadingIndicator';
import miniCart from '@/modules/MiniCart';
import explodingAccordion from '@/modules/explodingAccordion';
import menuSelector from '@/modules/MenuSelector';
import liveChat from '@/modules/liveChat';
import emailSignup from '@/modules/EmailSignup';
import geoPrompt from '@/modules/geoPrompt';

// Utils
import '@/utils/axios/index';
import {updateASMHeader} from '@/utils/asmAdjustments';

export class Shell {
  constructor(pageComponents = {}) {
    this.vue = vue;
    this.store = store;
    this.pageComponents = pageComponents;

    vue.config.devtools = !window.ACC.config.isProduction;
  }

  initializeVue() {
    this.loadPlugins();

    const vm = new vue({
      store,
      el: '#page',
      components: {
        ...this.pageComponents,
        compareBar,
        compareRackContainer,
        TrekButton,
        TrekLink,
        TrekFooter,
      },
      methods: {
        toast(options) {
          this.$notify(options);
        },

        mounted() {
          if (this.$validator) {
            this.$validator.localize(this.$store.state.vvLocale);
          }
        },
      },
    });

    store.commit('backend/setB2b', window.ACC.isB2Bsite);
    window.store = store;
    window.toast = vm.toast;
    window.vm = vm;
  }

  loadPlugins() {
    // Load common plugins here
    vue.use(v2s);
    vue.mixin(common);
    vue.prototype.$notify = notification;
  }

  preLoadInits() {
    // Necessary evil for current temporary solution for critical css
    window.loadNonCriticalCSS = (nonCriticalCSSPath) => {
      // Create CSS link tag to be inserted in head
      let nonCriticalCSSLink = document.createElement('link');
      nonCriticalCSSLink.rel = 'stylesheet';
      nonCriticalCSSLink.href = nonCriticalCSSPath;
      nonCriticalCSSLink.type = 'text/css';

      nonCriticalCSSLink.onload = () => {
        // Remove critical CSS after link has loaded
        let criticalCSSElement = $('#criticalCSS');
        if (criticalCSSElement) {
          criticalCSSElement.remove();
        }

        // Used by automation to determine when to start testing after page has stabilized
        window.isCSSLoaded = true;
      };

      // Find the critical css (located at the head) and insert the link tag right next to it
      let criticalCSSElement = document.getElementById('criticalCSS');
      criticalCSSElement.insertAdjacentElement('afterend', nonCriticalCSSLink);

      // Ensures the owl carousel displays correctly after noncritical css loads.
      if (window.sliderRefs != undefined && window.sliderRefs.length) {
        window.sliderRefs.forEach(function(slider) {
          $(slider).trigger('to.owl.carousel', 0);
        });
      }
    };
  }

  globalDocumentReadyInits() {
    // adding a global loading indicator
    window.loadingIndicator = loadingIndicator();

    // Live Chat
    liveChat();

    // Enables top nav interactions
    menuSelector($(document));

    // ASM Adjustments
    updateASMHeader();

    // Geo Prompt
    if ($('.geo-prompt-modal').length) {
      geoPrompt();
    }

    // Footer Email Sign Up Script
    emailSignup();
  }

  globalOnLoadInits() {
    $(window).trigger('resize');
    miniCart(document);

    // Footer expanding accordions in mobile
    const explodingAccordions = $(document).find('[data-accordion-explode]');
    explodingAccordions.each((i, t) => {
      explodingAccordion($(t));
    });
  }
}
